
import {
  Component, Vue, Prop, Watch
} from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import {
  productTypeListPC,
  getProductList,
  sizeList,
  productNaturePrice,
  addCart,
  browser_history
} from '@/services/http';
import { readCookie } from '@/tools/tools';
import SKU from '@/common/sku.vue';
import { Action, State, Mutation } from 'vuex-class';

@Component({
  components: {
    Price,
    SKU
  }
})
export default class extends Vue {
  // 分类列表
  productTypeList: any[] = []

  // 分类列表子分类
  productTypeChildren: any[] = []

  status: boolean = false

  debounceTimer: any = null

  Timer: any = null

  parentTypeId: string = ''

  // 导航第一个分类id
  firstProductId: string = ''

  currentIndex: number = 0

  currentSubIndex: number = 0

  printerModel: String = ''

  pageNo: number = 1

  pageSize: number = 10

  recommendList: any[] = []

  loading: boolean = false

  objData: Object = {}

  totalPages: number = 1

  disabled: boolean = false

  dataList: any = []

  FilePathPcimg: String = ''

  token: string = ''

  arrList: any = []

  activeIndex: String = '全部'

  sizeStauts: boolean = false

  clickFlag: number = 0 // 商品列表添加刷新点击标识刷新0，点击1

  // get noMore() {
  //   return this.pageNo >= this.totalPages - 1;
  // }

  // get disabled() {
  //   return this.loading || this.noMore;
  // }
  @State('equipment') printerModelInfor: any

  @Action('card/setCardNum') setCardNum!: Function

  @Action('white/setWhiteStauts') setWhiteStauts!: Function

  @Prop({ default: false }) private isFixed!: boolean

  @Watch('printerModelInfor', { deep: true })
  async onPrinterModelChange(newModel: any, oldModel: any) {
    // 检查 newModel 是否真的存在且有变化，避免不必要的请求

    // if (newModel && newModel.printerModel) {
    // 当 state 变化时，调用 handData 方法重新获取尺寸列表
    this.printerModel = newModel?.printerModel?.printerModel || '';
    this.recommendList = [];
    await this.getProductTypeList();
    await this.handSize();
    this.currentIndex = 0;
    this.currentSubIndex = 0;

    // }
  }

  created() {
    this.token = readCookie('accessToken') || '';
    this.disabled = true;
    this.clickFlag = 0;
    // this.getProductTypeList()
  }

  async handSize() {
    await sizeList({
      productTypeId: this.firstProductId ? this.firstProductId : this.parentTypeId, // 二级分类编号
      productParentTypeId: this.parentTypeId, // 一级分类编号
      printerModel: this.printerModel // 打印机型号
    }).then((res: any) => {
      this.arrList = res.data.data;
      this.arrList.unshift('全部');
      this.activeIndex = '全部';
    });
  }

  // 浏览更多
  watchMore(id: number) {
    this.$router.push(`/classify?parentTypeId=${id}`);
  }

  private goDetails(list: any) {
    if (list.productSku) {
      this.$router.push(
        `/details?id=${list.id}&productPriceId=${list.natureIds}&from=hotlist&PriceIds=${list.productPriceId}`
      );
    } else {
      this.$router.push(`/details?id=${list.id}&from=hotlist&PriceIds=${list.productPriceId}`);
    }

    sessionStorage.setItem('detailsList', JSON.stringify(list));
  }

  // 选择分类
  async selectMenu(productTypeId: string, index: number) {
    this.currentIndex = index;
    this.currentSubIndex = 0;
    this.pageNo = 1;
    this.totalPages = 1;
    this.disabled = false;
    this.recommendList = [];
    this.clickFlag = 0;
    this.parentTypeId = productTypeId;
    this.firstProductId = this.productTypeList[this.currentIndex]?.children[0]?.id;

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = window.setTimeout(() => {
      this.getProductList();
      this.handChangId();
      this.handSize();
    }, 1000);
  }

  // 选择二级分类
  async selectSubMenu(productTypeId: string, index: number) {
    this.pageNo = 1;
    this.totalPages = 1;
    this.clickFlag = 1;
    this.currentSubIndex = index;
    // this.parentTypeId = ''
    this.firstProductId = productTypeId;
    this.disabled = false;
    this.recommendList = [];

    if (this.Timer) {
      clearTimeout(this.Timer);
    }
    this.Timer = window.setTimeout(() => {
      this.handChangId();
      this.handSize();
      this.getProductList();
    }, 1000);
  }

  private async getProductTypeList() {
    const res: any = await productTypeListPC({
      companyId: 1,
      printerModel: this.printerModel // 打印机型号
    });

    if (res.data.code === 100) {
      this.productTypeList = res.data.data;
      this.parentTypeId = res.data.data.length !== 0 ? res.data.data[0].id : '';
      this.firstProductId = res.data.data?.[0]?.children?.[0]?.id || '';

      this.handChangId();
      this.getProductList();
    }
  }

  // 切换分类id
  handChangId() {
    const obj = {
      productTypeId: this.firstProductId,
      parentTypeId: this.parentTypeId
    };
    // this.$emit('handTypeId', obj)
  }

  handOverall() {
    this.sizeStauts = !this.sizeStauts;
  }

  handChat(item: any) {
    this.FilePathPcimg = item.listImagePath.cdnFilePathPc;
    const anchor = readCookie('anchor');
    productNaturePrice({
      productId: item.id,
      companyId: 1
    }).then((res: any) => {
      if (res.data.code == 100 && res.data.data.nature[0].data.length > 1) {
        this.objData = {
          FilePathPcimg: this.FilePathPcimg,
          pricelist: res.data.data?.price,
          selectarr: res.data.data?.nature?.[0]?.data || []
        };
        (this as any).$refs.skuRefs.handSku(this.objData);

        return;
      }

      addCart({
        productPriceId: item.productPriceId,
        num: 1,
        equip: anchor ? anchor.equip : '',
        version: anchor ? anchor.version : '',
        companyId: 1
      }).then((res: any) => {
        if (res.data.code == 100) this.$message.success('加入购物车成功');
        this.setCardNum();
        this.setWhiteStauts();
      });
    });
  }

  handClick(index: String) {
    this.activeIndex = index;
    this.recommendList = [];
    this.getProductList();
    this.sizeStauts = false;
  }

  onInfinite() {
    if (!this.disabled && !this.status) {
      this.pageNo += 1;
      this.getProductList();
    }
  }

  // 获取商品分页列表
  async getProductList() {
    if (this.loading) return;
    //  this.recommendList = []
    this.loading = true;
    this.status = true;
    const anchor = readCookie('anchor');
    const res: any = await getProductList({
      keyword: '',
      productTypeId: this.firstProductId,
      parentTypeId: this.parentTypeId,
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      model: anchor ? anchor.model : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      clickFlag: this.clickFlag,
      companyId: 1,
      printerModel: this.printerModel, // 设备类型
      size: this.activeIndex == '全部' ? '' : this.activeIndex
    });
    if (res.data.code === 100) {
      this.recommendList = [...this.recommendList, ...res.data?.data?.list];
      this.totalPages = res.data.data?.lastPage;
      this.disabled = this.pageNo > this.totalPages - 1;
      this.status = false;
    } else {
      this.$message.error(res.data.message);
    }
    this.loading = false;
  }
}
